import React from "react";
import Collapse from 'react-bootstrap/Collapse';

export default class OptionMetadataEditor extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      collapsed: true
    };
  }

  render() {
    const iconClass = this.state.collapsed ? "fa-plus" : "fa-minus";
    const hideToggleButton = (this.props.form_attribute.display_type === "select" 
      && this.props.keenform.use_simple_scoring === false
      && this.props.form_attribute.metadata_types.length === 0
    );
    return (<>
      {
        hideToggleButton ? 
        undefined :
        <button
          type="button"
          role="button"
          onClick={ this.toggleMetadataSection }
          className={`btn btn-secondary btn-sm`}>
            <i className={`fa ${iconClass}`}></i> 
            &nbsp;additional data
        </button>
      }
      <Collapse in={!this.state.collapsed}>
        <div className="option-metadata-list">
          { ["radio", "checkbox"].includes(this.props.form_attribute.display_type) &&
            <div className="row">
              <label htmlFor="option_description" className="metadata-label form-label col-md-4 col-sm-12">description:</label>
              <textarea 
                className="form-control col-md-8 col-sm-12"
                cols="75"
                placeholder="(will appear inside option below label)"
                name={`form_attribute[form_attribute_options_attributes][${this.props.option_index}][description]`}
                defaultValue={this.props.option.description}>
              </textarea>
            </div>
          }
          {
            this.props.keenform.use_simple_scoring &&
            <div className="row mt-3">
              <label className="form-label metadata-label col-md-4 col-sm-12">score</label>
              <input 
                type="number"
                className="option-score-value-input form-control col-md-8 col-sm-12 text-right"
                disabled={!this.props.keenform.use_simple_scoring}
                defaultValue={this.props.option.score_value}
                name={`form_attribute[form_attribute_options_attributes][${this.props.option_index}][score_value]`} 
                id={`form_attribute_form_attribute_options_attributes_${this.props.option_index}_score_value`} />
            </div>
          }
          { this.props.form_attribute.metadata_types.map((mdtType, index) => {
              return this.renderInputForMetadata(mdtType, index);
            })
          }
        </div>
      </Collapse>
    </>);
  }

  getInputForMetadata = (metadataType, mdtValue) => {
    const inputName = `form_attribute[form_attribute_options_attributes][${this.props.option_index}][metadata][${metadataType.uuid}]`;
    switch (metadataType.display_type) {
      case "text": // TODO this should be a constant
        return <input
          type="text"
          className="form-control col-md-8 col-sm-12"
          data-metadata-name={metadataType.name}
          data-metadata-uuid={metadataType.uuid}
          name={inputName}
          defaultValue={mdtValue} />;
      case "number": // TODO this should be a constant
        let stepValue = 1;
        if ( metadataType.number_precision ) {
          stepValue = 1 / (10 ** metadataType.number_precision);
        }
        // if input is for currency then format the value?
        const decimalPrecision = metadataType.number_precision ? metadataType.number_precision : 0;
        // error: zero renders blanl
        let defaultValue = mdtValue;
        if (defaultValue !== null && defaultValue !== undefined) { // !== null & mdtValue !== undefined ? mdtValue.toFixed(decimalPrecision) : undefined;
          defaultValue = mdtValue.toFixed(decimalPrecision);
        } 
        return <input 
          type="number"
          className="form-control col-md-8 col-sm-12 text-right"
          name={inputName}
          data-metadata-name={metadataType.name}
          data-metadata-uuid={metadataType.uuid}
          step={stepValue}
          defaultValue={defaultValue} />;
      case "singleselect": // TODO this should be a constant
        return this.getSelectTagForMetadata(metadataType, mdtValue);
      default:
        console.log('unaccounted for metadata type: ', metadataType);
        return <div>under construction</div>;
    }
  }

  getSelectTagForMetadata = (metadataType, mdtValue) => {
    const inputName = `form_attribute[form_attribute_options_attributes][${this.props.option_index}][metadata][${metadataType.uuid}]`;
    return (<select 
      name={inputName}
      className="form-control col-md-8 col-sm-12"
      data-metadata-name={metadataType.name}
      data-metadata-uuid={metadataType.uuid}
      defaultValue={mdtValue}>
        <option value=""></option>
        {metadataType.options.map(opt => <option value={opt.value}>{opt.value}</option>)}
      </select>);
  }

  renderInputForMetadata = (metadataType, index) => {    
    const optionsMetadata = (!!this.props.option.metadata ? this.props.option.metadata : []); 
    const optionMetadataValue = optionsMetadata[metadataType.name];
    return (
      <div className="row mt-3" key={index}>
        <label className="metadata-label form-label col-md-4 col-sm-12">{metadataType.name}:</label>
        {this.getInputForMetadata(metadataType, optionMetadataValue) }
      </div>
    );
  }

  toggleMetadataSection = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

}